enum VisibilityEnum {
  xs,
  sm,
  md,
  lg,
  xl
}

export default VisibilityEnum;
